import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Form, Input, Select, Space, Tooltip } from "antd";
import { useMemo } from "react";
import { useI18n } from "../../../../../../../contexts/i18n.js";
const FormServiceFieldTechnicalDefinitionsCookieDuration = ({ field, readOnly })=>{
    const { __ } = useI18n();
    const durations = useMemo(()=>({
            s: __("second(s)"),
            m: __("minute(s)"),
            h: __("hour(s)"),
            d: __("day(s)"),
            mo: __("month(s)"),
            y: __("year(s)")
        }), [
        __
    ]);
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.technicalDefinitions[field.name]?.type !== nextValues.technicalDefinitions[field.name]?.type || prevValues.technicalDefinitions[field.name]?.isSessionDuration !== nextValues.technicalDefinitions[field.name]?.isSessionDuration,
        children: ({ getFieldValue })=>{
            const type = getFieldValue([
                "technicalDefinitions",
                field.name,
                "type"
            ]);
            const isSessionDuration = getFieldValue([
                "technicalDefinitions",
                field.name,
                "isSessionDuration"
            ]);
            if ([
                "local",
                "session",
                "indexedDb",
                "flash"
            ].indexOf(type) > -1) {
                return null;
            }
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: [
                            field.name,
                            "isSessionDuration"
                        ],
                        noStyle: true,
                        valuePropName: "checked",
                        children: /*#__PURE__*/ _jsx(Checkbox, {
                            style: {
                                float: "left",
                                marginTop: 5
                            },
                            disabled: readOnly,
                            children: /*#__PURE__*/ _jsx(Tooltip, {
                                title: __("This cookie is active as long as the session is active"),
                                children: /*#__PURE__*/ _jsx("span", {
                                    children: __("Session")
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Space.Compact, {
                        block: true,
                        style: {
                            width: "100%",
                            maxWidth: 200,
                            display: isSessionDuration ? "none" : undefined
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                name: [
                                    field.name,
                                    "duration"
                                ],
                                noStyle: true,
                                dependencies: [
                                    [
                                        "technicalDefinitions",
                                        field.name,
                                        "isSessionDuration"
                                    ]
                                ],
                                rules: [
                                    {
                                        required: !isSessionDuration,
                                        message: __("Please provide a valid duration!")
                                    }
                                ],
                                style: {
                                    flex: 1,
                                    minWidth: 0,
                                    margin: 0
                                },
                                children: /*#__PURE__*/ _jsx(Input, {
                                    disabled: readOnly,
                                    min: "0",
                                    type: "number"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Form.Item, {
                                name: [
                                    field.name,
                                    "durationUnit"
                                ],
                                noStyle: true,
                                dependencies: [
                                    [
                                        "technicalDefinitions",
                                        field.name,
                                        "isSessionDuration"
                                    ]
                                ],
                                rules: [
                                    {
                                        required: !isSessionDuration,
                                        message: __("Please provide an unit!")
                                    }
                                ],
                                style: {
                                    flex: "0 0 auto",
                                    margin: 0
                                },
                                children: /*#__PURE__*/ _jsx(Select, {
                                    disabled: readOnly,
                                    style: {
                                        minWidth: 100
                                    },
                                    children: Object.keys(durations).map((key)=>/*#__PURE__*/ _jsx(Select.Option, {
                                            value: key,
                                            children: durations[key]
                                        }, key))
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
};
export { FormServiceFieldTechnicalDefinitionsCookieDuration };
